module.exports = __webpack_public_path__ + "staticfr/media/agua.e49695d6.mp4";